var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import ServiceInterfaceService from '../../../api/ServiceInterfaceService';
import { Loading } from 'element-ui';
import VueDialog from "../../../interface/IVueDialog";
import PayDialog from '../components/PayDialog';
var RechargeDialog = (function (_super) {
    __extends(RechargeDialog, _super);
    function RechargeDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selectIndex = 0;
        _this.data = {
            "service_name": "",
            "supplier_name": "",
            "total_amount": 0,
            "invoice_num": "0",
            "predict_num": 0,
            "list": []
        };
        _this.curItem = null;
        return _this;
    }
    RechargeDialog.prototype.created = function () {
        this.service = ServiceInterfaceService.getInstance();
    };
    RechargeDialog.prototype.mounted = function () {
        this.chargeInfo();
    };
    RechargeDialog.prototype.chargeInfo = function () {
        var _this = this;
        this.service.chargeInfo({ api_type: this.api_type }).then(function (res) {
            _this.data = res.data.data;
            _this.curItem = _this.data.list[0];
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    RechargeDialog.prototype.changeSelect = function (index) {
        this.selectIndex = index;
        this.curItem = this.data.list[index];
        console.log(this.selectIndex);
    };
    RechargeDialog.prototype.close = function () {
        this.$closeDialog();
    };
    RechargeDialog.prototype.confirm = function () {
        var _this = this;
        if (this.curItem.charge_type == 99 && !this.curItem.amount) {
            this.$message.error('请先输入自定义充值次数');
            return;
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        var param = {
            id: this.curItem.id,
            api_type: this.curItem.api_type,
            charge_type: this.curItem.charge_type,
            amount: this.curItem.amount,
            money: this.curItem.charge_type == 99 ? (this.curItem.money * this.curItem.amount).toFixed(2) : this.curItem.money,
            payment_type: 12
        };
        this.service.recharge(param).then(function (res) {
            loadingInstance.close();
            var qrcodePath = res.data.data.qrcode_path;
            var order_id = res.data.data.order_id;
            var instance = _this.$dialog(PayDialog, {
                data: {
                    qrcodePath: qrcodePath,
                    order_id: order_id
                }
            }, {
                title: "支付二维码",
                width: 600,
                height: 420
            }).instance;
            instance.$on('paySuccess', function () {
                _this.$message.success('缴费成功！');
                _this.$closeDialog();
                _this.$emit('paySuccessEdit');
            });
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    RechargeDialog = __decorate([
        Component
    ], RechargeDialog);
    return RechargeDialog;
}(VueDialog));
export default RechargeDialog;
